import { blue, red } from 'bold-ui/lib/styles/colors'
import { isUndefinedOrNull } from 'util/checks'

import { BadgeProps } from './BadgeNotificacao'

export const MAX_LIMIT_NOTIFICATION_COUNT_DEFAULT = 99

export const useBadgeConfig = (props: BadgeProps, color: string) => {
  const getFinalColor = () => {
    if (color === 'red') return red.c50
    if (color === 'blue') return blue.c50
    return color
  }

  const isLarge = props.type === 'large' || (props.type === 'auto' && typeof props.value !== 'boolean')
  const isSmall = props.type === 'small'
  const isOverPictograma = !isUndefinedOrNull(props.children)

  const maxLimit =
    isLarge && 'maxLimit' in props && !isUndefinedOrNull(props.maxLimit)
      ? props.maxLimit
      : MAX_LIMIT_NOTIFICATION_COUNT_DEFAULT

  const getDisplayValue = () => {
    if (!isLarge) return null
    if (typeof props.value === 'string') return props.value.slice(0, 5)
    if (typeof props.value === 'number') return props.value > maxLimit ? `${maxLimit}+` : props.value
    return null
  }

  const shouldRenderBadge = !(props.value === 0 || props.value === false || isUndefinedOrNull(props.value))

  return {
    finalColor: getFinalColor(),
    isLarge,
    isSmall,
    isOverPictograma,
    displayValue: getDisplayValue(),
    shouldRenderBadge,
  }
}
